module.exports = __webpack_public_path__ + "media/img/naked-logo-eb47360e4a17a92676d5584eb043ea24.png";